<template>
    <div class="d-flex flex-row">
        <statusbar-icon v-if="normalUser"
            :tooltipText="simple_tooltip"
            :iconClass="simple_class"
            icon="circle"
        />
        <div v-else class="d-flex flex-row">
            <statusbar-icon v-if="incompleteSettings"
                :tooltipText="t_incomplete"
                :iconClass="simple_class"
                icon="circle"
                />
            <statusbar-icon
                :tooltipText="t_transmissions + ': ' + errorDetailsTransmissions"
                :iconClass="transmissions_class"
                icon="right-left"
            />
            <statusbar-icon
                :tooltipText="t_syslog + ': ' + errorDetailsSyslog"
                :iconClass="syslog_class"
                icon="gear"
            />
            <statusbar-icon
                :tooltipText="t_playlog + ': ' + errorDetailsPlaylog"
                :iconClass="playlog_class"
                icon="screen"
                eicon
            />
            <statusbar-icon v-if="esign"
                :tooltipText="t_esign + ': ' + errorDetailsESign"
                :iconClass="esign_class"
                icon="esign"
                eicon
            />
            <statusbar-icon
                :tooltipText="t_mms + ': ' + errorDetailsMMS"
                :iconClass="ftp_class"
                icon="server"
                eicon
            />
            <statusbar-icon
                :tooltipText="t_database + ': ' + errorDetailsDB"
                :iconClass="db_class"
                icon="database"
                eicon
            />
        </div>
        <div class="ml-2">
            <slot />
        </div>
    </div>
</template>

<script>

    import StatusbarIcon from "./statusbar-icon.vue";
    import {FormatDateTimeEntryToLocaleString} from "../../../../utils/date";

    export default {
        components: {StatusbarIcon},
        props: [
            'esign',
            'normalUser',
            'incompleteSettings'
        ],
        data: function () {
            return {
                t_errors: Lang.langChoice("Error|Errors", 1),
                t_all_ok: Lang.langGet("Everything looks good."),
                t_transmission_warning: Lang.langGet("The transmissions queue seems to be processed slowly."),
                t_transmission_error: Lang.langGet("The transmissions queue is processed too slow."),
                t_database: Lang.langGet("Database"),
                t_mms: Lang.langGet("Server"),
                t_playlog: Lang.langGet("Playlog"),
                t_syslog: Lang.langGet("Syslog"),
                t_transmissions: Lang.langGet("Transmissions"),
                t_no_connection: Lang.langGet("Connection to the target could not be established."),
                t_esign: Lang.langGet("eSign"),
                t_systemstatus: Lang.langGet("System Status"),
                t_incomplete: Lang.langGet("Project Settings incomplete."),
                project_id: Laravel.activeProject,
                db_has_error: true,
                ftp_has_error: true,
                esign_has_error: true,
                playlog_has_error: true,
                syslog_has_error: true,
                transmissions_has_error: true,
                transmissions_has_warning: false,
                errorDetailsDB: '',
                errorDetailsMMS: '',
                errorDetailsESign: '',
                errorDetailsPlaylog: '',
                errorDetailsSyslog: '',
                errorDetailsTransmissions: '',
            }
        },
        computed: {
            simple_class: function () {
                let hasError = this.ftp_has_error || this.db_has_error || (this.esign == true && this.esign_has_error) || this.transmissions_has_error;
                let hasMildError = this.playlog_has_error || this.syslog_has_error || this.transmissions_has_warning;

                if (hasError) {
                    return 'text-danger';
                } else if (hasMildError) {
                    return 'text-warning';
                } else {
                    return 'text-success';
                }
            },
            simple_tooltip: function () {
                if (this.simple_class === 'text-success') {
                    return this.t_all_ok;
                }

                let resultText = '';

                if (this.db_has_error) {
                    resultText += this.t_database + ': ' + this.errorDetailsDB + '<br/>';
                }

                if (this.ftp_has_error) {
                    resultText += this.t_mms + ': ' + this.errorDetailsMMS + '<br/>';
                }

                if (this.esign_has_error) {
                    resultText += this.t_esign + ': ' + this.errorDetailsESign + '<br/>';
                }

                if (this.playlog_has_error) {
                    resultText += this.t_playlog + ': ' + this.errorDetailsPlaylog + '<br/>';
                }

                return resultText
            },
            ftp_class: function () {
                return this.ftp_has_error ? 'text-danger' : 'text-success';
            },
            db_class: function () {
                return this.db_has_error ? 'text-danger' : 'text-success';
            },
            esign_class: function () {
                return this.esign_has_error ? 'text-danger' : 'text-success';
            },
            playlog_class: function () {
                return this.playlog_has_error ? 'text-warning' : 'text-success';
            },
            syslog_class: function () {
                return this.syslog_has_error ? 'text-warning' : 'text-success';
            },
            transmissions_class: function () {
                if (this.transmissions_has_error) {
                    return 'text-danger';
                } else if (this.transmissions_has_warning) {
                    return 'text-warning';
                } else {
                    return 'text-success';
                }
            }
        },
        methods: {
            t_log_error: function (count) {
                if (count< 0) {
                    count = Lang.langGet('[unknown]');
                }
                return Lang.langGet("No entries for more than :days days.", {days: count});
            },
            loadStatus: function () {
                axios.get('/checkstatus/' + this.project_id).then((data) => {
                    const ftp_pre = this.ftp_has_error;
                    if (data.data.FTP === 0) {
                        this.ftp_has_error = false;
                        this.errorDetailsMMS = this.t_all_ok;
                    } else if (data.data.FTP === -1) {
                        this.ftp_has_error = true;
                        this.errorDetailsMMS = this.t_no_connection;
                    } else {
                        this.ftp_has_error = true;
                        this.errorDetailsMMS = data.data.FTP;
                    }
                    if (data.data.FTP !== 0) {
                        this.errorDetailsMMS += " " + Lang.langGet("Down since") + ": " + FormatDateTimeEntryToLocaleString(data.data.downtime_server);
                    }

                    if (data.data.DB === 0) {
                        this.db_has_error = false;
                        this.errorDetailsDB = this.t_all_ok;
                    } else if (data.data.DB === -1) {
                        this.db_has_error = true;
                        this.errorDetailsDB = this.t_no_connection;
                    } else {
                        this.db_has_error = true;
                        this.errorDetailsDB = data.data.DB;
                    }
                    if (data.data.DB !== 0) {
                        this.errorDetailsDB += " " + Lang.langGet("Down since") + ": " + FormatDateTimeEntryToLocaleString(data.data.downtime_db);
                    }

                    if (data.data.eSign === 0) {
                        this.esign_has_error = false;
                        this.errorDetailsESign = this.t_all_ok;
                    } else if (data.data.eSign === -1) {
                        this.esign_has_error = true;
                        this.errorDetailsESign = this.t_no_connection;
                    } else {
                        this.esign_has_error = true;
                        this.errorDetailsESign = data.data.eSign;
                    }
                    if (data.data.eSign !== 0) {
                        this.errorDetailsESign += " " + Lang.langGet("Down since") + ": " + FormatDateTimeEntryToLocaleString(data.data.downtime_esign);
                    }

                    if (data.data.playlog === 0) {
                        this.playlog_has_error = false;
                        this.errorDetailsPlaylog = this.t_all_ok;
                    } else {
                        this.playlog_has_error = true;
                        this.errorDetailsPlaylog = this.t_log_error(data.data.playlog);
                    }

                    if (data.data.syslog === 0) {
                        this.syslog_has_error = false;
                        this.errorDetailsSyslog = this.t_all_ok;
                    } else if (data.data.syslog?.toString().startsWith('high')) {
                        this.syslog_has_error = true;
                        let syslog_error = data.data.syslog?.toString().split('|');
                        this.errorDetailsSyslog = Lang.langGet("Unusually high amount of entries (:saved/:max).", {'saved': syslog_error[1], 'max': syslog_error[2]});
                    } else {
                        this.syslog_has_error = true;
                        this.errorDetailsSyslog = this.t_log_error(data.data.syslog);
                    }

                    if (data.data.downtime_transmissions) {
                        if (data.data.transmissions <= 200) {
                            this.transmissions_has_warning = true;
                            this.transmissions_has_error = false;
                            this.errorDetailsTransmissions = data.data.transmissions + ' - ' + this.t_transmission_warning;
                        } else if (data.data.transmissions > 200) {
                            this.transmissions_has_warning = false;
                            this.transmissions_has_error = true;
                            this.errorDetailsTransmissions = data.data.transmissions + ' - ' + this.t_transmission_error;
                        }
                        this.errorDetailsTransmissions += " " + Lang.langGet("since") + ": " + FormatDateTimeEntryToLocaleString(data.data.downtime_transmissions);
                    } else {
                        this.transmissions_has_error = false;
                        this.transmissions_has_warning = false;
                        this.errorDetailsTransmissions = this.t_all_ok;
                        if (data.data.transmissions> 0) {
                            this.errorDetailsTransmissions = data.data.transmissions + ' - ' + this.errorDetailsTransmissions;
                        }
                    }
                    if (ftp_pre !== this.ftp_has_error) {
                        EaseEventBus.fire('serverErrorChanged', this.ftp_has_error);
                    }
                }).catch(function (error) {
                    console.error(error);
                });
            }
        },
        mounted() {
            this.loadStatus();

            setInterval(() => {
                this.loadStatus();
            }, 60000); // check every 60 seconds
        }
    }
</script>
